function optIn(featureName, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/optIn/${featureName}`;
  return apiClient.post(route);
}

function optOut(featureName, currentLocation, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/optIn/${featureName}`;
  return apiClient.delete(route, { currentLocation });
}

export default {
  optIn,
  optOut
};
